import { styled, Box } from '@mui/material';

export const OrderedList = styled('ol')(({ theme }) => ({
  counterReset: 'item-counter',
  paddingLeft: theme.spacing(2),
  [theme.breakpoints.down('sm')]: {
    paddingLeft: theme.spacing(1),
  },
  listStyle: 'none',
  '& li': {
    counterIncrement: 'item-counter',
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
    '&::before': {
      content: 'counter(item-counter, decimal-leading-zero)',
      backgroundColor: theme.palette.secondary.dark,
      color: theme.palette.secondary.contrastText,
      borderRadius: theme.shape.borderRadius,
      padding: theme.spacing(0.25),
      width: theme.spacing(5),
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginRight: theme.spacing(2),
      fontSize: '0.875rem',
      fontWeight: 'bold',
      flexShrink: 0,
    },
    '& *': {
      display: 'contents',
    },
  },
})) as typeof Box;

export default OrderedList;
